import Vue from 'vue';
import Component from 'vue-class-component';

const LAYOUT_HORIZONTAL:string = 'horizontal';
const LAYOUT_VERTICAL:string = 'vertical';
const RESIZER_SIZE:number=0.4;


@Component({
  name: 'multipane',
  props: {
    layout: {
      type: String,
      default: LAYOUT_VERTICAL
    }
  }
})
export default class Multipane extends Vue {

  //public static readonly LAYOUT_HORIZONTAL:string = 'horizontal';
  //public static readonly LAYOUT_VERTICAL:string = 'vertical';
  layout: string;

  isResizing: boolean = false;

  get classNames(): string[] {
    let result:string[] = ['multipane',
      'layout-' + this.layout.slice(0, 1),
      this.isResizing ? 'is-resizing' : ''];

     // console.log('Hier ist');
      
     // console.dir(result);

      return result;
  }

  get cursor(): string {
    let result:string = this.isResizing ? this.layout == LAYOUT_VERTICAL ? 'col-resize' : 'row-resize' : '';
    
    //console.log("hier->cursor");
    //console.dir(result);
    return result;
  }

  get userSelect(): string {
    let result:string=  this.isResizing ? 'none' : '';
    //console.log("Hier-> userSelect");
    //console.dir(result);
    return result;
  }


  onMouseDown(event:MouseEvent) {
    let resizer:Element=<Element>event.target;
    let initialPageX = event.pageX;
    let initialPageY = event.pageY;

    //console.log('STATIC-MEMBER: ',  LAYOUT_HORIZONTAL);
    
    if (resizer.className && resizer.className.match('multipane-resizer')) {
    
      let { $el: container, layout } = this;

      let paneLeft:HTMLElement = <HTMLElement>resizer.previousElementSibling;
      let paneRight:HTMLElement =<HTMLElement>resizer.nextElementSibling; 
      let {
        offsetWidth: initialPaneWidth,
        offsetHeight: initialPaneHeight,
      } = <HTMLElement>paneLeft;


      //console.log('PANE: ',paneLeft);
      
      //console.log('OFFSET-Widt:'+initialPaneWidth+" OFFSET-Height:"+initialPaneHeight);
      

      let usePercentage = (paneLeft.style.width + '').match('%');

      //console.log('PERCENTAGE - ',usePercentage);
      
      const { addEventListener, removeEventListener } = window;

      const resize = (initialSize, offset = 0) => {
        let result:string='not assigned result';
        if (layout == LAYOUT_VERTICAL) {
          let containerWidth = container.clientWidth;
          let paneWidth = initialSize + offset;

          result = (paneLeft.style.width = paneWidth + 'px')
          paneRight.style.width=container.clientWidth - paneWidth - resizer.clientWidth+'px';
            /* usePercentage
            ? paneWidth / containerWidth * 100 + '%'
            : paneWidth + 'px');
*/
         // paneWidth + 'px';
          return result;
        }

        if (layout == LAYOUT_HORIZONTAL) {
          let containerHeight = container.clientHeight;
          let paneHeight = initialSize + offset;

          result = (paneLeft.style.height = usePercentage
            ? paneHeight / containerHeight * 100 + '%'
            : paneHeight +'px');

            return result;
        }
      };

      // This adds is-resizing class to container
      this.isResizing = true;

      // Resize once to get current computed size
     // let size = resize(initialPaneWidth,0);
      let size=initialPaneWidth+'';
      //console.log('RESIZE_SIZE= ', size);      

      // Trigger paneResizeStart event
      this.$emit('paneResizeStart', paneLeft, resizer, size);
      //console.log('THIS THIS THIS Global',this);

      const onMouseMove = (mouseev:MouseEvent) =>{
      
       let  { pageX, pageY }=mouseev;
        size =
          layout == LAYOUT_VERTICAL
            ? resize(initialPaneWidth, pageX - initialPageX)
            : resize(initialPaneHeight, pageY - initialPageY);

        this.$emit('paneResize', paneLeft, resizer, size);
      };

      const onMouseUp = () => {
        // Run resize one more time to set computed width/height.
       /* size =
          layout == LAYOUT_VERTICAL
            ? resize(paneLeft.clientWidth)
            : resize(paneLeft.clientHeight); 
*/
        // This removes is-resizing class to container
        this.isResizing = false;
        //console.log('THIS THIS THIS MOUSE-UP',this);
        

        container.removeEventListener('mousemove', onMouseMove);
        container.removeEventListener('mouseup', onMouseUp);

        this.$emit('paneResizeStop', paneLeft, resizer, size);
      };

      container.addEventListener('mousemove', onMouseMove);
      container.addEventListener('mouseup', onMouseUp);
    }
  }





  /*

  onMouseDown(objectInfo: { resizer: Element, initialPageX: number, initialPageY: number }) {
    if (objectInfo.resizer.className && objectInfo.resizer.className.match('multipane-resizer')) {
      let pane: Element = objectInfo.resizer.previousElementSibling;
      let { $el: container, layout } = this;

      let { offsetWidth: initialPageWidth,
        offsetHeight: initialPageHeight } = <HTMLElement>pane;

 
      let usePercentage = !!((<HTMLElement>pane).style.width + '').match('%');

      const { addEventListener, removeEventListener } = window;


      
      this.isResizing = true;
      
      //resize(container, pane,layout, initialSize,offset,usePercentage);

      this.$emit('paneResizeStart',pane,objectInfo.resizer, this.resize);

    }
  }

  onMouseMove(container:HTMLElement,pane: HTMLElement, pageX:number, pageY:number,initialPageX:number,
    initialPageY:number,
     size:string, layout: string,
    usePercentage:boolean): void {
    size =
    layout == Multipane.LAYOUT_VERTICAL
      ? this.resize(initialPaneWidth, pageX - initialPageX)
      : this.resize(initialPaneHeight, pageY - initialPageY);

    this.$emit('paneResize', pane, resizer, size);
  }

  onMouseUp(container:HTMLElement,pane: HTMLElement, pageX:number, pageY:number,
    initialPageX:number,
    initialPageY:number,
    size:string, layout: string,
    usePercentage:boolean): void
  {
    size =
    layout == Multipane.LAYOUT_VERTICAL
      ? this.resize(initialPaneWidth, pageX - initialPageX)
      : this.resize(initialPaneHeight, pageY - initialPageY);

    this.isResizing = false;

    this.$emit('paneResizeStop', pane, resizer, size);   
  }


  resize(container: HTMLElement, pane: HTMLElement,
    layout: string, initialSize: number,
    offset: number = 0, usePercentage: boolean): string
    
  {
    if (layout == Multipane.LAYOUT_VERTICAL) {
      let containerWidth = container.clientWidth;
      let paneWidth = initialSize + offset;

      return (pane.style.width = usePercentage ? paneWidth / containerWidth * 100 + '%' :
        paneWidth + 'px');
    }


    if (layout == Multipane.LAYOUT_HORIZONTAL) {
      let containerHeight = container.clientHeight;
      let paneHeight = initialSize + offset;

      return (pane.style.height = usePercentage ? paneHeight / containerHeight * 100 + '%' :
        paneHeight + 'px');
    }
  }


*/

}
